import React from 'react';
import Icon from "../";
export default function IconArrowTopRight(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<line x1=\"5.47\" y1=\"18.53\" x2=\"18.69\" y2=\"5.31\" fill=\"none\" stroke=\"#181818\"/><polyline points=\"8 5.3 18.69 5.31 18.71 16\" fill=\"none\" stroke=\"#181818\"/>"
    }
  }));
}